import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MethodSection } from './components/MethodSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white-soft font-sans text-gray-800" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <MethodSection data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <AudienceSection data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}